var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.klass},[_c('p',{class:_vm.colorTextClass},[_c('v-icon',{attrs:{"color":_vm.colorIcon}},[_vm._v(_vm._s(_vm.getIcon()))]),_vm._v(" "+_vm._s(_vm.message)+" ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }